<template>
    <div>
        <div class="max-w-5xl">
            <CHeading class="mb-12"> Pravidlá používania platformy GROWNi </CHeading>

            <RulesContent />
        </div>
    </div>
</template>

<script setup lang="ts">
const { t } = useI18n()
useHead({
    title: t('rules.title'),
    meta: [{ name: 'description', content: t('rules.description') }]
})
</script>
